import React, { useRef } from "react";
import { arrayOf, bool, instanceOf, shape, string } from "prop-types";
import { useFormError } from "@magento/peregrine/lib/talons/FormError/useFormError";
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import defaultClasses from "./formError.module.scss";
import { useScrollIntoView } from "@magento/peregrine/lib/hooks/useScrollIntoView";
import { Redirect } from "@magento/venia-drivers";
var FormError = props => {
  var {
    classes: propClasses,
    errors,
    scrollOnError
  } = props;
  var talonProps = useFormError({
    errors
  });
  var {
    errorMessage
  } = talonProps;
  var errorRef = useRef(null);
  useScrollIntoView(errorRef, scrollOnError && errorMessage);
  var classes = mergeClasses(defaultClasses, propClasses);
  return errorMessage ? /*#__PURE__*/React.createElement("div", {
    className: classes.root,
    ref: errorRef
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.errorMessage
  }, errorMessage)) : null;
};
export default FormError;
FormError.propTypes = {
  classes: shape({
    root: string,
    errorMessage: string
  }),
  errors: arrayOf(instanceOf(Error)),
  scrollOnError: bool
};
FormError.defaultProps = {
  scrollOnError: true
};